import { Navigate, Outlet, useLocation } from 'react-router-dom';

function ProtectedRoute({ isAllowed, redirectPath = '/login', isAuthenticated = true, unauthorizedRedirectPath = '/', children }) {
    const location = useLocation();
    const urlParams = new URLSearchParams(window.location.search);
    const redirectUrl = urlParams.get('redirectUrl');

    if (!isAllowed) {
        // If user is not authenticated, redirect to login with current path as redirectUrl
        if (!isAuthenticated) {
            const currentPath = location.pathname + location.search;
            const finalRedirectUrl = redirectUrl || currentPath;
            const navigatePath =
                finalRedirectUrl !== redirectPath && finalRedirectUrl !== '/'
                    ? `${redirectPath}?redirectUrl=${encodeURIComponent(finalRedirectUrl)}`
                    : redirectPath;

            return <Navigate to={navigatePath} replace />;
        } else {
            // If user is authenticated but lacks permission, redirect to unauthorized path (homepage)
            return <Navigate to={unauthorizedRedirectPath} replace />;
        }
    }

    return children ? children : <Outlet />;
}

export default ProtectedRoute;
